import React, { useEffect, useRef, useState } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import DataTable, { TableStyles } from 'react-data-table-component';
import { Button } from '@app/components';
 import { getAllActiveFranchise } from '@app/services/franchise';
import Select from "react-select";
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { getAllLeadStatus, getLeadPercentageByFranchiseId, getLeadsWithPagination } from '@app/services/lead';
import { getAllActiveSubjects } from '@app/services/subject';
import UpdateLeadStatusModal from './UpdateLeadStatusModal';
import { Form } from 'react-bootstrap';
import ExcelJS from "exceljs/dist/es5/exceljs.browser";
import fileDownload from 'js-file-download';
import ProgressBar from 'react-bootstrap/ProgressBar';

const ListLeads = () => {

    const canAccess = useSelector((state: any) => state.auth.permissions.lead);
    const navigate = useNavigate()
    const [t] = useTranslation()
    useEffect(() => {
        if(canAccess.list == false){
            toast.error(t('auth.noAccess'))
            navigate('/')
        }
    }, [])
    let obj: any = {}
    const selectRef = useRef(null);
    const [leads, setLeads] = useState([]);
    const [subjects, setSubjects] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams()
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(searchParams.get('perPage') ?? 10);
    const [currentPage, setCurrentPage] = useState(searchParams.get('page') ?? 1);
    const [franchises, setFranchises] = useState([]);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [payload, setPayload] = useState({});
    const [leadStauses, setLeadStauses] = useState([]);
    const [leadPer, setLeadPercentage] = useState(obj);
    const [toDateError, setToDateError] = useState('');
    const [fromDateError, setFromDateError] = useState('');

    const customStyle: TableStyles = {
        head: {
            style: {
                color: "#5E5873",
                fontSize: "13px",
                fontWeight: 900,
            },
        },
        headCells: {
            style: {
                borderColor: "#E9ECEF",
                textTransform: "uppercase",
                letterSpacing: "1px",
            },
        },
        headRow: {
            style: {
                backgroundColor: "#F7F7F8",
                minHeight: "44px",
                fontWeight: 500,
            },
        },
    };

    const customStylesSelect = {
        dropdownIndicator: () => ({
            display: 'none',
        }),
    }

    useEffect(() => {
        if(searchParams.get('fromDate') != null && searchParams.get('toDate') == null){
            setToDateError('Please select To date')
        }else{
            setToDateError('')
        }

        if(searchParams.get('fromDate') == null && searchParams.get('toDate') != null){
            setFromDateError('Please select From date')
        }else{
            setFromDateError('')
        }

        let fromDate = new Date(searchParams.get('fromDate')).getTime();
        let toDate = new Date(searchParams.get('toDate')).getTime();

        if((searchParams.get('fromDate') == null && searchParams.get('toDate') == null) || (searchParams.get('fromDate') != null && searchParams.get('toDate') != null)){
            if (fromDate > toDate) {
                setFromDateError('From date must be less than To date')
            } else {
                setFromDateError('')
                getAllLeads()
            }
        }
    },[searchParams]);

    useEffect(() => {
        getAllActiveFranchiseData()
        getAllActiveSubjectsAPI()
        getAllLeadStatusAPI()
    },[]);

    const getAllLeads = async () => {
        try {
            setLoading(true);
            const resp = await getLeadsWithPagination(searchParams);
            if (resp.success === true) {
                setLoading(false);
                setLeads(resp.collections.data);
                setTotalRows(resp?.collections?.pagination?.total);
                searchParams.get('franchiseId') ? getLeadPercentageByFranchise(searchParams.get('franchiseId'), searchParams) : ''
            } else {
                setLoading(false);
                toast.error(resp?.errors[0]?.msg);
            }
        } catch (error: any) {
            setLoading(false);
            toast.error(error?.message || 'Internal Server Error')
        }
    };

    const getAllActiveFranchiseData = async () => {
        try {
            const resp = await getAllActiveFranchise();
            if (resp?.success === true) {
                setFranchises(resp?.collections);
            } else {
                toast.error(resp?.errors[0]?.msg);
            }
        } catch (error: any) {
            toast.error(error?.message || 'Internal Server Error')
        }
    };

    const getAllActiveSubjectsAPI = async () => {
        try {
            const resp = await getAllActiveSubjects()
            if (resp.success === true) {
                setSubjects(resp.collections);
            } else {
                toast.error(resp?.errors[0]?.msg);
            }
        } catch (error: any) {
            toast.error(error?.message || 'Internal server error');
        }
    };

    const getAllLeadStatusAPI = async () => {
        try {
            const resp = await getAllLeadStatus()
            if (resp.success === true) {
                setLeadStauses(resp?.collections)
            } else {
                toast.error(resp?.errors[0]?.msg);
            }
        } catch (error: any) {
            toast.error(error?.message || 'Internal server error');
        }
    };

    const getLeadPercentageByFranchise = async (franchiseId, searchParams) => {
        try {
            const resp = await getLeadPercentageByFranchiseId(franchiseId, searchParams)
            if (resp.success === true) {
                setLeadPercentage(resp?.collections)
            } else {
                toast.error(resp?.errors[0]?.msg);
            }
        } catch (error: any) {
            toast.error(error?.message || 'Internal server error');
        }
    };

    const columns = [
        {
            name: 'Parent',
            selector: (row: { parent_name: string;}) => row.parent_name,
            sortable: true,
            sortField: 'parent_name',
            wrap: true,
        },
        {
            name: 'Phone',
            selector: (row: { parent_phone: string; }) => row.parent_phone ? row.parent_phone : '---',
            sortable: false,
            sortField: 'parent_phone',
        },
        {
            name: 'Student',
            selector: (row: {student_name: string;}) => row.student_name,
            sortable: true,
            sortField: 'student_name',
            wrap: true,
        },
        {
            name: 'Franchise',
            selector: (row: { franchise_name: string; }) => row.franchise_name ? row.franchise_name : '---',
            sortable: true,
            sortField: 'franchise_name',
            wrap: true,
        },
        {
            name: 'Subject',
            selector: (row: { subject_name: string; }) => row.subject_name ? row.subject_name : '---',
            sortable: true,
            sortField: 'subject_name',
        },
        // {
        //     name: 'Ass Location',
        //     selector: (row: { assessment_location: string; }) => row.assessment_location ? row.assessment_location : '---',
        //     sortable: true,
        //     sortField: 'assessment_location',
        //     wrap: true,
        // },
        {
            name: 'Enquiry Date',
            selector: (row: { inquiry_date: string; }) => row.inquiry_date ? row.inquiry_date : '---',
            cell: (row: { inquiry_date: string; }) => (
                row.inquiry_date ? moment(row.inquiry_date).format('DD/MM/YYYY') : '---'
            ),
            sortable: true,
            sortField: 'inquiry_date',
        },
        {
            name: 'Status',
            selector: (row: { status: string; }) => row.status,
            // cell: (row: { status: string; }) => (
            //     row.status === 'Enrolled and Paid' ? <span className="uppercase badge bg-success">Enrolled and Paid</span> : (row.status === 'Lost' ? <span className="uppercase badge bg-danger">{row.status}</span> : <span className="uppercase badge bg-warning">{row.status}</span>)
            // ),
            cell: ({ lead_inquiry_status_id, status }) => {
                let badgeClass = "bg-warning"; // default

                if (lead_inquiry_status_id === 9) {
                    badgeClass = "bg-danger";
                } else if ([7, 8, 12].includes(lead_inquiry_status_id)) {
                    badgeClass = "bg-success";
                }

                return (
                    <span className={`uppercase badge ${badgeClass}`}>
                        {status}
                    </span>
                );
            },
            sortable: true,
            sortField: 'status',
            width: '16%',
        },
        {
            name: 'Status Updated On',
            selector: (row: { status_updated_date: string; }) => row.status_updated_date,
            cell: (row: { status_updated_date: string; }) => (
                row.status_updated_date ? moment(row.status_updated_date).format('DD/MM/YYYY') : '---'
            ),
            sortable: true,
            sortField: 'status_updated_date',
        },
        {  
            name: 'Action',
            cell: (row: { parent_email: string, parent_phone: string, subject_name: string, lead_inquiry_student_subject_id: number, lead_inquiry_student_id: number, lead_inquiry_status_id: number, parent_read_only: boolean}) => (
              <>
                { canAccess['view-journey'] &&
                    <Link
                    to={`/leads/${row.lead_inquiry_student_id}/view-journey`}
                    role="button"
                    state={{ lead_inquiry_student_id: row.lead_inquiry_student_id }}
                    data-toggle="tooltip" title="View Journey"
                    >
                    <i className="fas fa-eye mr-2"/>
                    </Link>
                }
                { canAccess['status-update'] && row.lead_inquiry_status_id != 7 &&
                    <a href='javascript:void(0)' onClick={ (e) => { handleUpdateStatus(row.parent_email, row.parent_phone, row.subject_name, row.lead_inquiry_student_id, row.lead_inquiry_student_subject_id, row.parent_read_only)}} data-toggle="tooltip" title="Update Lead status">
                        <i className="fas fa-user-edit"></i>
                    </a>
                }
              </>
            ),
            // minWidth: '14%'
        },
    ];

    const handlePageChange = page => {
        searchParams.set('page', page)
        setSearchParams(searchParams)
        
        setCurrentPage(page);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        searchParams.set('perPage', newPerPage)
        setSearchParams(searchParams)
        
        setPerPage(newPerPage);
    };

    const handleSort = async (column, sortDirection) => {
        searchParams.set('sortField', column.sortField)
        searchParams.set('sortDirection', sortDirection)
        setSearchParams(searchParams)
    };

    const handleResetFilter = async () => {
        selectRef.current.setValue('');
        searchParams.delete('parentName')
        searchParams.delete('studentName')
        searchParams.delete('franchiseId')
        searchParams.delete('subjectId')
        searchParams.delete('leadStatusId')
        searchParams.delete('updatedDate')
        searchParams.delete('fromDate')
        searchParams.delete('toDate')
        searchParams.delete('page')
        searchParams.delete('sortField')
        searchParams.delete('sortDirection')
        setSearchParams(searchParams)  
    };

    const onChangeFranchise = (option) => {
        searchParams.set('franchiseId', option == null ? '' : option.id )
        setSearchParams(searchParams)
        option ? getLeadPercentageByFranchise(option.id, searchParams) : setLeadPercentage({})
    };

    const handleUpdateStatus = async(email, phone, subject_name, lead_inquiry_student_id, lead_inquiry_student_subject_id, parent_read_only) => {
        handleShow();
        setPayload({parent_email: email, parent_phone: phone,subject_name: subject_name,lead_inquiry_student_id: lead_inquiry_student_id, lead_inquiry_student_subject_id: lead_inquiry_student_subject_id, parent_read_only: parent_read_only})
    }

    const exportCSV = async() => {
        try {
            setLoading(true);
            searchParams.set('perPage', totalRows.toString())
            let records = await getLeadsWithPagination(searchParams)
            searchParams.set('perPage', '10')
            if (records.success === true) {
                setLoading(false);
            } else {
                setLoading(false);
                toast.error(records?.errors[0]?.msg);
                return;
            }

            if((records?.collections?.data).length === 0){
                toast.error('Records not found.')
                return;
            }

            const workbook = new ExcelJS.Workbook();
            workbook.addWorksheet("leads");
            const worksheet = workbook.getWorksheet('leads');
            worksheet.columns = [
                { header: "Name of Franchise", key: "franchise_name" },
                { header: "Date Of Enquiry", key: "inquiry_date" },
                { header: "How they got in touch", key: "got_in_touch" },
                { header: "Where did you hear/find out about us?", key: "found_us_via" },
                { header: "Name of Lead Parent", key: "parent_name" },
                { header: "Name of Student", key: "student_name" },
                { header: "Assessment Location", key: "assessment_location" },
                { header: "Phone Number", key: "parent_phone" },
                { header: "Email", key: "parent_email" },
                { header: "Subject", key: "subject_name" },
                { header: "Age", key: "age" },
                { header: "Status", key: "status" },
                { header: "Recent Comment", key: "recent_comment" },
                { header: "Status Updated On", key: "status_updated_date" },
            ];
            
            (records?.collections?.data).map((row) => {
                row.franchise_name = row.franchise_name !== null ? row.franchise_name : '---';
                row.inquiry_date = (row.inquiry_date != null) ? moment(row.inquiry_date).format('DD/MM/YYYY') : '---';
                row.status_updated_date = (row.status_updated_date != null) ? moment(row.status_updated_date).format('DD/MM/YYYY') : '---';
                row.got_in_touch = row.got_in_touch !== null ? row.got_in_touch : '---';
                row.found_us_via = row.found_us_via !== null ? row.found_us_via : '---';
                row.parent_name = (row.parent_name != null) ? row.parent_name : '---';
                row.student_name = (row.student_name != null) ? row.student_name : '---';
                row.assessment_location = (row.assessment_location != null) ? row.assessment_location : '---';
                row.parent_phone = (row.parent_phone != null) ? row.parent_phone : '---';
                row.parent_email = (row.parent_email != null) ? row.parent_email : '---';
                row.recent_comment = (row.recent_comment != null) ? row.recent_comment : '---';
            })

            worksheet.addRows(records?.collections?.data);
            let filename = 'Leads-' + moment().format('DD-MMM-YYYY') + '.csv';

            workbook.csv.writeBuffer().then(function(buffer) {
                fileDownload(buffer, filename);
            });
        } catch (error: any) {
            setLoading(false);
            toast.error(error?.message || 'Internal Server Error')
        }
    };

    return (
        <div>
            <div>
                {/* Content Header (Page header) */}
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1>Manage Leads</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item active">Manage Leads</li>
                                </ol>
                            </div>
                        </div>
                    </div>{/* /.container-fluid */}
                </section>
                {/* Main content */}
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div style={{ marginBottom: 10 }} className="row">
                                    
                                </div>
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">Manage Leads</h3>
                                        <div className="col-lg-12 text-right">
                                            { canAccess?.create &&
                                                <Link className="btn btn-primary" to="/leads/add" > + Add New Lead </Link>
                                            }
                                        </div>
                                    </div>
                                    {/* /.card-header */}
                                    <div className="card-body">
                                        <div className="row mb-2">
                                            <div className="col-sm-2">
                                                <label>Parent Name</label>
                                                <input type="text" name='parentName' className="form-control" value={searchParams.get('parentName') ?? ''} onChange={(e) => {searchParams.set('parentName', e.target.value); setSearchParams(searchParams)}} placeholder="Search By Parent Name" />
                                            </div>
                                            <div className="col-sm-2">
                                                <label>Student Name</label>
                                                <input type="text" name='studentName' className="form-control" value={searchParams.get('studentName') ?? ''} onChange={(e) => {searchParams.set('studentName', e.target.value); setSearchParams(searchParams)}} placeholder="Search By Student Name" />
                                            </div>
                                            <div className="col-sm-2">
                                                <label>Franchise</label>
                                                <Select
                                                    ref={selectRef}
                                                    name="franchiseId"
                                                    placeholder="Search By Franchise"
                                                    options={franchises}
                                                    getOptionValue={(option)=>`${option['id']}`}
                                                    getOptionLabel={(option)=>`${option['name']}`}
                                                    onChange={ (option) => {onChangeFranchise(option)}}
                                                    value={franchises.filter(function(option) {
                                                        return option.id == searchParams.get('franchiseId');
                                                    })}
                                                    isClearable={true}
                                                    styles={customStylesSelect}
                                                />
                                            </div>
                                            <div className="col-sm-2">
                                                <label>Subject</label>
                                                <select
                                                    className="form-control"
                                                    name="subjectId"
                                                    onChange={(e) => {  searchParams.set('subjectId', e.target.value); setSearchParams(searchParams)}}
                                                    value={searchParams.get('subjectId') ?? ''}
                                                >
                                                    <option value="">Search By Subject</option>
                                                    {subjects.map((obj) => (
                                                        <option key={obj.id} value={obj.id}>
                                                            {obj.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-sm-2">
                                                <label>Lead Status</label>
                                                <select
                                                    className="form-control"
                                                    name="leadStatusId"
                                                    onChange={(e) => {  searchParams.set('leadStatusId', e.target.value); setSearchParams(searchParams)}}
                                                    value={searchParams.get('leadStatusId') ?? ''}
                                                >
                                                    <option value="">Search By Status</option>
                                                    {leadStauses.map((obj) => (
                                                        <option key={obj.id} value={obj.id}>
                                                            {obj.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            {/* <div className="col-sm-2">
                                                <label>Date Of Inquiry</label>
                                                <Form.Control 
                                                    type="date" 
                                                    name="dateOfInquiry" 
                                                    id="dateOfInquiry" 
                                                    placeholder="Enter date of inquiry" 
                                                    value={searchParams.get('dateOfInquiry') ?? ''} 
                                                    onChange={(e) => {searchParams.set('dateOfInquiry', e.target.value); setSearchParams(searchParams)}}
                                                />
                                            </div> */}
                                            <div className="col-sm-2">
                                                <label>Updated Date</label>
                                                <Form.Control 
                                                    type="date" 
                                                    name="updatedDate" 
                                                    id="updatedDate" 
                                                    placeholder="Enter updated date" 
                                                    value={searchParams.get('updatedDate') ?? ''} 
                                                    onChange={(e) => {searchParams.set('updatedDate', e.target.value); setSearchParams(searchParams)}}
                                                />
                                            </div>
                                        </div>
                                        <div className='row mb-2'>
                                             <div className="col-sm-2">
                                                <label>Enquiry From Date</label>
                                                <Form.Control
                                                    type="date"
                                                    name="created_from_date" 
                                                    id="created_from_date" 
                                                    placeholder="Enter from date" 
                                                    value={searchParams.get('fromDate') ?? ''} 
                                                    onChange={(e) => {searchParams.set('fromDate', e.target.value); setSearchParams(searchParams)}}
                                                />
                                                <div className="text-danger">
                                                    { fromDateError }
                                                </div>
                                            </div>
                                            <div className="col-sm-2">
                                                <label>Enquiry To Date</label>
                                                <Form.Control
                                                    type="date"
                                                    name="created_to_date" 
                                                    id="created_to_date" 
                                                    placeholder="Enter to date" 
                                                    value={searchParams.get('toDate') ?? ''} 
                                                    onChange={(e) => {searchParams.set('toDate', e.target.value); setSearchParams(searchParams)}}
                                                />
                                                <div className="text-danger">
                                                    { toDateError }
                                                </div>
                                            </div>
                                            <div className='col-sm-3' style={{marginTop: '32px'}}>
                                                <Button type="submit" isLoading={isLoading} onClick={handleResetFilter} className="btn btn-warning mr-2">Reset Filter</Button>
                                                { canAccess['export-csv'] &&
                                                    <Button type="submit" isLoading={isLoading} onClick={exportCSV} className="btn btn-success"><i className="fas fa-file-csv"></i> Export</Button>
                                                }
                                            </div>
                                        </div>

                                        { searchParams.get('franchiseId') && leadPer?.total_leads > 0 && (
                                            <div className="row mb-3">
                                                <div className="col-12">
                                                    <div style={{border: '1px solid #17a2b8', borderRadius: '4px', padding: '10px', overflow: 'hidden'}}>
                                                        <label>Franchise Lead Conversion Percenatage <i className='fa fa-info-circle' title='You can filter the report by franchise, subject, parent name, and student name.'/></label>
                                                        <ProgressBar style={{overflow: 'hidden'}}>
                                                            <ProgressBar striped variant="success" title={`${leadPer?.enrolled?.percentage} % (Confirmed)`} now={leadPer?.enrolled?.percentage} label={`${leadPer?.enrolled?.percentage} % (Confirmed)`} key={1} />
                                                            <ProgressBar variant="warning" title={`${leadPer?.in_progress?.percentage} % (In-progress)`} now={leadPer?.in_progress?.percentage} label={`${leadPer?.in_progress?.percentage} % (In-progress)`} key={2} />
                                                            <ProgressBar striped variant="danger" title={`${leadPer?.lost?.percentage} % (Lost)`} now={leadPer?.lost?.percentage} label={`${leadPer?.lost?.percentage} % (Lost)`} key={3} />
                                                        </ProgressBar>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        <DataTable
                                            columns={columns}
                                            data={leads}
                                            pagination
                                            paginationServer
                                            paginationTotalRows={totalRows}
                                            paginationDefaultPage={Number(currentPage)}
                                            onChangePage={handlePageChange}
                                            onChangeRowsPerPage={handlePerRowsChange}
                                            paginationPerPage={Number(perPage)}
                                            paginationRowsPerPageOptions={[5, 10, 20, 30, 50, 100]}
                                            progressPending={isLoading}
                                            sortServer
                                            onSort={handleSort}
                                            customStyles={customStyle}
                                        />
                                    </div>
                                    {/* /.card-body */}
                                </div>
                            </div>
                            {/* /.col */}
                        </div>
                        {/* /.row */}
                    </div>
                    {/* /.container-fluid */}
                </section>
                {/* /.content */}
                <UpdateLeadStatusModal
                    show={show}
                    handleClose={handleClose}
                    reload={getAllLeads}
                    payload={payload}
                />
            </div>
        </div>
    )
};

export default ListLeads;